import { component as MODULE } from '../store/state';

const ACTIONS = {
  GET_FREIGABE_NEUER_MANDANT: `${MODULE}get_freigabe_neuer_mandant`,
};

export default ACTIONS;
